import React from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';

import { createFormValidationFn } from 'client/helpers/formikHelpers';

import {
  UTILITY_INTERNET_RENTING_MODEM_YES,
  UTILITY_INTERNET_RENTING_MODEM_NO,
  UTILITY_INTERNET_LESS_THAN_6MONTHS_NO,
  UTILITY_INTERNET_LESS_THAN_6MONTHS_YES,
} from 'common/utility/constants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import { SR_CHECKBOX_THEME_BOX } from 'client/components/Checkbox';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

const getFormFields = (providerName) => {
  return [
    {
      id: 'rentingModem',
      title: 'Are you currently renting your modem?',
      type: 'multiple_choice',
      properties: {
        multipleSelection: false,
        useArrayValues: false,
        fieldType: SR_CHECKBOX_THEME_BOX,
        choices: [
          {
            value: UTILITY_INTERNET_RENTING_MODEM_YES,
            label: 'Yes',
          },
          { value: UTILITY_INTERNET_RENTING_MODEM_NO, label: 'No' },
        ],
        autoFitWidth: '100%',
      },
      validations: ['required'],
    },
    {
      id: 'contractLength',
      title: `How long have you been with ${providerName || 'your internet provider'}?`,
      type: 'multiple_choice',
      properties: {
        multipleSelection: false,
        useArrayValues: false,
        fieldType: SR_CHECKBOX_THEME_BOX,
        choices: [
          {
            value: UTILITY_INTERNET_LESS_THAN_6MONTHS_NO,
            label: 'Less than 6 months',
          },
          {
            value: UTILITY_INTERNET_LESS_THAN_6MONTHS_YES,
            label: 'More than 6 months',
          },
        ],
        autoFitWidth: '100%',
      },
      validations: ['required'],
    },
  ];
};

const SrUtilitySetupTransferInternetFlowCurrentPlanDetailsModal = ({
  providerName,
  onSubmit,
  onBack,
}) => {
  return (
    <SrSimpleMessageModal
      iconUrl="/images/emoji-wifi.png"
      contentContainerClassName="utilityProviderContact"
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      iconBgColor="#EBF4FF"
      maxIconHeight="100px"
      maxIconWidth="100px"
      headline={
        <SrBox maxWidth="300px" margin="0 auto">
          <SrText fontSize="24px" weight="800" font="greycliff">
            Enter your current {providerName || 'internet'} plan.
          </SrText>
        </SrBox>
      }
      underline
      message={
        <SrBox textAlign="left">
          <Formik
            onSubmit={onSubmit}
            validate={createFormValidationFn(getFormFields())}
            render={(formikBag) => {
              const formFields = getFormFields(providerName);
              return (
                <Form>
                  {formFields.map((formField) => (
                    <SrFormikField
                      key={formField.id}
                      formField={formField}
                      formikBag={formikBag}
                      className={SR_FIELD_THEME_ADOBE}
                    />
                  ))}
                  <SrBox marginTop="30px">
                    <SrButton
                      type="submit"
                      disabled={!formikBag.isValid}
                      theme={SR_BUTTON_THEME_ADOBE_GREEN}
                    >
                      Next
                    </SrButton>
                  </SrBox>
                  <SrBox marginTop="12px">
                    <SrButton type="button" theme={SR_BUTTON_THEME_ADOBE_GREY} onClick={onBack}>
                      Back
                    </SrButton>
                  </SrBox>
                </Form>
              );
            }}
          />
        </SrBox>
      }
    />
  );
};

SrUtilitySetupTransferInternetFlowCurrentPlanDetailsModal.propTypes = {
  providerName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

SrUtilitySetupTransferInternetFlowCurrentPlanDetailsModal.displayName =
  'SrUtilitySetupTransferInternetFlowCurrentPlanDetailsModal'; // eslint-disable-line max-len

export default SrUtilitySetupTransferInternetFlowCurrentPlanDetailsModal;
